import Path from '@leverege/path';

/**
 * This creates a listener that compute the new value/model using the
 * modelClass and to fire the change to the onChange function in the
 * props object. If the data in the event is a string, it is assumed
 * that it represents a method name. So if evt.data = "setX", then 
 * modelClass["setX"]( evt.value ) will invoked to get the new value.
 * If evt.data is an object, then each key represents a method, and 
 * the value represents the field name in the evt.value. So if evt.data
 * is { "setX" : 'xPos', "setY" : 'yPos' }, then this will be invoked:
 *    let nValue = modelClass["setX"]( value, evt.value['xPos'] )
 *    nValue = modelClass["setY"]( nValue, evt.value['yPos'] )
 */
function createFireChange(modelKey) {
  return (modelClass, props, evt) => {
    try {
      const {
        [modelKey]: model,
        onChange,
        eventData
      } = props;
      let nModel = model;
      if (typeof evt.data === 'string') {
        nModel = modelClass[evt.data](model, evt.value);
      } else if (evt.data && typeof evt.data === 'object' && !Array.isArray(evt.data)) {
        const keys = Object.keys(evt.data);
        keys.forEach(key => {
          const p = evt.data[key];
          if (typeof p === 'string') {
            const v = Path.get(evt.data[key], evt.value, null);
            nModel = modelClass[key](nModel, v);
          } else if (typeof p === 'function') {
            nModel = modelClass[key](nModel, p(evt.value));
          }
        });
      }
      if (nModel !== model && onChange) {
        const changes = Object.keys(nModel).filter(k => {
          return nModel[k] !== model[k];
        });
        // Grab any that may have been removed
        Object.keys(model).forEach(k => {
          if (nModel[k] === undefined && !changes.includes(k)) {
            changes.push(k);
          }
        });
        onChange({
          value: nModel,
          changing: false,
          data: eventData,
          changes,
          oldValue: model
        });
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };
}
const fireModelChange = createFireChange('model');
const fireValueChange = createFireChange('value');
export default {
  fireModelChange,
  fireValueChange,
  createFireChange
};
export { fireModelChange, fireValueChange, createFireChange };